const validateEmail = (email) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIyZTUyODA4My0zMmI2LTRjZjItODI3Ni1hNTQxMzQ5ODA5MWMiLCJ2ZXJpZmFsaWE6cm9sZSI6InJvb3QiLCJ2ZXJpZmFsaWE6cGVybWlzc2lvbnMiOiIqIiwidmVyaWZhbGlhOmZlYXR1cmVzIjoie1widGhyb3R0bGluZ1wiOntcIm1heFJ1bGVzUGVyVXNlclwiOjV9fSIsInZlcmlmYWxpYTpjdXJyZW5jeSI6IkVVUiIsImV4cCI6MTcxMzI1Njc0OSwiaXNzIjoidmVyaWZhbGlhLmNvbSIsImF1ZCI6InZlcmlmYWxpYS5jb20ifQ.0ZWzw49k0i2QzOYOjx_Laj7lxWzLtDlGbgPeymnZ2j0");

  const raw = JSON.stringify({
    "entries": [
      {
        "inputData": email
      }
    ]
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  // Return a promise
  return new Promise((resolve, reject) => {
    fetch("https://api.verifalia.com/v2.5/email-validations", requestOptions)
      .then(response => response.json())
      .then(data => {
        console.log('data',data)
        if (data.code === 402) {
          console.log('rejecting error')
          reject(data); // Reject the promise with data if code is 400
        } else {
          const classification = data.entries.data[0].classification;
          console.log("Classification:", classification);
          resolve(classification); // Resolve the promise with classification
        }
      })
      .catch(error => {
        console.error('Error:', error);
        reject(error); // Reject the promise with error
      });
  });
};